export default "__VITE_ASSET__c8d73142__"